export default "__VITE_ASSET__IOHDzSZj__"